import type { SVGProps } from "react";

export function IconBlackGlobe(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32 4.25C16.6741 4.25 4.25 16.6741 4.25 32C4.25 47.3259 16.6741 59.75 32 59.75C47.3259 59.75 59.75 47.3259 59.75 32C59.75 16.6741 47.3259 4.25 32 4.25ZM32.3003 16.8V20.85H47.5002L54.2502 28.5L57.4479 25.5348C55.7072 18.6623 51.2558 12.8702 45.2981 9.36279L37.7003 16.8H32.3003ZM5.78299 33.3275C5.76108 32.8878 5.75 32.4452 5.75 32C5.75 20.8819 12.6621 11.3782 22.4234 7.55168L15 21.15H10.45V30.95L5.78299 33.3275ZM20 55.3528C14.4829 52.512 10.1026 47.7735 7.72194 42H13L20 49V55.3528ZM27.9497 37.4H34.6997V42.8V48.2H40.0997L44.1497 40.775L48.1997 33.35L42.7997 25.25H32.3747L27.9497 27.25V37.4Z"
        fill="#23232C"
      />
    </svg>
  );
}
